// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"5cfb2634","69":"9c4b3493","137":"47be6b24","167":"12934610","287":"90c65e27","369":"b3379f7a","568":"165d3c60","670":"168bc8ea","921":"c8c59c8c"}[chunkId] + ".chunk.js";
};